import { createApp } from 'vue';
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router';


 


// 定义路由
const routes = [
   { path: '/:code', component: App }
];

// 创建Router实例
const router = createRouter({
  history: createWebHistory(),
  routes
});

// 创建Vue实例，并将router配置注入
const app = createApp(App);
app.use(router);
app.mount('#app');